// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpRightFromSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-right-from-square': IconArrowUpRightFromSquare;
    }
}

/**
 * The icon component for the 'arrowUpRightFromSquare' icon
 */
export class IconArrowUpRightFromSquare extends Icon {
    public constructor() {
        super(arrowUpRightFromSquare16X16);
    }
}

registerIcon('icon-arrow-up-right-from-square', IconArrowUpRightFromSquare);
export const iconArrowUpRightFromSquareTag = 'nimble-icon-arrow-up-right-from-square';
